import $ from 'jquery';
import Cache from 'root/cache';
import Constants from 'root/constants';
import View from 'view/base';
import View_User_Property_Filter from 'view/user_identification/user_property_filter';

export default View.extend({
    className: 'feedback-filters',

    views: {
        user_property_filter: {}
    },

    selected_filters: {
        workflow       : [],
        feedback_type  : [],
        assignee       : [],
        priority       : [],
        category       : [],
        segment        : [],
        user_property  : null,
        include_merged : false
    },

    events: {
        'click .user-filter-toggle' : 'onToggleUserFilter',
        'click li[data-filter]'     : 'onDropdownSelect'
    },

    dom_handlers: {
        onToggleUserFilter: function(e) {
            this.$el.find('.region-user-properties').toggle();
        },

        onDropdownSelect: function(e) {
            // allow multiple select without closing the dropdown
            e.stopPropagation();

            if ($(e.currentTarget).hasClass('disabled')) {
                return;
            }

            var dropdown_name = $(e.currentTarget).parents('[data-type]:first').data('type');
            var filter_name = $(e.currentTarget).data('filter');
            var filter_val  = $(e.currentTarget).data('val');

            var filter_type = typeof this.selected_filters[filter_name];

            if (filter_type === 'boolean') {
                this.selected_filters[filter_name] = !this.selected_filters[filter_name];
            } else {
                var filter_options = this.getFilterOptions(filter_name);
                var is_single_select = ['segment'].includes(filter_name);

                if (filter_val === -1) {
                    this.selected_filters[filter_name] = [];
                } else if (is_single_select) {
                    this.selected_filters[filter_name] = [filter_val];
                } else {
                    if (this.selected_filters[filter_name].length === 1 && this.selected_filters[filter_name][0] === filter_val) {
                        return;
                    }

                    if (this.selected_filters[filter_name].indexOf(filter_val) === -1) {
                        this.selected_filters[filter_name].push(filter_val);
                    } else {
                        this.selected_filters[filter_name].splice(this.selected_filters[filter_name].indexOf(filter_val), 1);
                    }

                    if (this.selected_filters[filter_name].length === filter_options.options.length) {
                        this.selected_filters[filter_name] = [];
                    }
                }
            }

            this.renderDropdown(dropdown_name);

            this.trigger('filter::change', this.selected_filters);
        },

        documentClick: function(e) {
            var ignore_classes = [
                'condition-delete',
                'region-user-properties',
                'user-filter-toggle'
            ];

            var ignore = false;

            ignore_classes.forEach((ignore_class) => {
                if ($(e.target).hasClass(ignore_class) || $(e.target).parents('.' + ignore_class).length > 0) {
                    ignore = true;
                }
            });

            if (ignore) {
                return;
            }

            this.$el.find('.region-user-properties').hide();
        }
    },

    event_handlers: {
        onWorkflowChange: function() {
            this.renderDropdown('workflow');
        },

        onUserChange: function() {
            this.renderDropdown('assignee');
        },

        onCategoryChange: function() {
            this.renderDropdown('category');
        },

        onUserPropertyFilterSubmit: function(conditions) {
            this.$el.find('.region-user-properties').hide();
            this.$el.find('.user-filter-toggle .count').text(conditions.segment_condition.length ? conditions.segment_condition.length : '');

            if (conditions.segment_condition.length) {
                this.selected_filters.user_property = conditions;
            } else {
                this.selected_filters.user_property = null;
            }

            this.trigger('filter::change', this.selected_filters);
        }
    },

    initialize: function(options) {
        this.is_design = !!options.is_design;

        this.selected_filters = {
            workflow       : options.workflow      || [],
            feedback_type  : options.feedback_type || [],
            assignee       : options.assignee      || [],
            priority       : options.priority      || [],
            category       : options.category      || [],
            segment        : options.segment       || [],
            user_property  : options.user_property || null,
            include_merged : !!options.include_merged
        };

        if (!this.is_design) {

        }

        this.listenTo(Cache.workflow,          'change:name', this.event_handlers.onWorkflowChange);
        this.listenTo(Cache.feedback_category, 'add',         this.event_handlers.onCategoryChange);
        this.listenTo(Cache.feedback_category, 'remove',      this.event_handlers.onCategoryChange);
        this.listenTo(Cache.user,              'add',         this.event_handlers.onUserChange);
        this.listenTo(Cache.user,              'remove',      this.event_handlers.onUserChange);

        // global events outside of the view el (e.g. document, window, body)
        $(document).on('click.' + this.cid, this.dom_handlers.documentClick.bind(this));

        this.on('remove', () => {
            $(document).off('click.' + this.cid);
        });
    },

    getFilterOptions: function(dropdown_type) {
        var options = [];

        switch (dropdown_type) {
            case 'workflow':
                Cache.workflow.where({project_id: Cache.default_project_id}).forEach((workflow_model) => {
                    options.push({
                        name: '<span class="workflow-option-colour" style="background-color:' + workflow_model.get('colour') + ';"></span>' + workflow_model.escape('name'),
                        val: workflow_model.id
                    });
                });

                options.push({
                    name: 'separator'
                });

                options.push({
                    name: 'Include Merged',
                    val: '',
                    filter: 'include_merged' // separate filter option
                });

                return {
                    label: 'Status',
                    options: options
                };
            case 'feedback_type':
                return {
                    label: 'Type',
                    options: [
                        {
                            name: 'Bug',
                            val: Constants.FEEDBACK_BUG
                        },
                        {
                            name: 'Idea',
                            val: Constants.FEEDBACK_FEATURE_REQUEST
                        },
                        {
                            name: 'General',
                            val: Constants.FEEDBACK_GENERAL
                        }
                    ]
                };
            case 'assignee':
                Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]).forEach((user) => {
                    options.push({
                        name: '<div class="flex-start"><div class="user-img-24 margin-right-4" style="background-image:url(\'' + user.getAvatar(32) + '\')"></div>' + user.escape('name') + '</div>',
                        val: user.id
                    });
                });

                options.push({
                    name: 'separator'
                });

                options.push({
                    name: '<div class="flex-start"><div class="user-img-24 margin-right-4" style="background-image:url(\'/image/profile.png\');"></div>Unassigned</div>',
                    val: 0
                });

                return {
                    label: 'Assignee',
                    options: options
                };
            case 'priority':
                return {
                    label: 'Priority',
                    options: [
                        {
                            name: '<span class="priority-flag-icon priority-text-urgent"><i class="fa-solid fa-flag"></i></span>Urgent',
                            val: 'urgent'
                        },
                        {
                            name: '<span class="priority-flag-icon priority-text-high"><i class="fa-solid fa-flag"></i></span>High',
                            val: 'high'
                        },
                        {
                            name: '<span class="priority-flag-icon priority-text-neutral"><i class="fa-solid fa-flag"></i></span>Neutral',
                            val: 'neutral'
                        },
                        {
                            name: '<span class="priority-flag-icon priority-text-low"><i class="fa-solid fa-flag"></i></span>Low',
                            val: 'low'
                        }
                    ]
                };
            case 'category':
                options.push({
                    name: 'Empty',
                    val: 0
                });

                Cache.feedback_category.where({project_id: Cache.default_project_id}).forEach(function(model) {
                    options.push({
                        name: model.escape('name'),
                        val: model.escape('name')
                    });
                });

                return {
                    label: 'Category',
                    options: options
                };
            case 'segment':
                Cache.user_segment.where({is_archived: false}).forEach((model) => {
                    options.push({
                        name: model.escape('segment_name'),
                        val: model.id
                    });
                });

                if (!options.length) {
                    options.push({
                        name: 'No segments created',
                        val: 0,
                        disabled: true
                    });
                }

                return {
                    label: 'Segment',
                    options: options
                };
        }
    },

    clear: function() {
        this.selected_filters = {
            workflow       : [],
            feedback_type  : [],
            assignee       : [],
            priority       : [],
            category       : [],
            segment        : [],
            user_property  : null,
            include_merged : false
        };

        this.render();
        this.trigger('filter::change', this.selected_filters);
    },

    update: function(options) {
        this.selected_filters = {...this.selected_filters, ...options};
        this.render();
    },

    renderDropdown: function(dropdown_name) {
        if (dropdown_name === 'user_property') {
            if (this.views.user_property_filter instanceof View_User_Property_Filter) {
                this.views.user_property_filter.remove();
            }

            this.views.user_property_filter = new View_User_Property_Filter({
                segment_type: this.selected_filters.user_property ? this.selected_filters.user_property.segment_type : Constants.USER_SEGMENT_TYPE_AND,
                segment_condition: this.selected_filters.user_property ? this.selected_filters.user_property.segment_condition : []
            });

            this.views.user_property_filter.render().$el.appendTo(this.$el.find('.region-user-properties'));
            this.listenTo(this.views.user_property_filter, 'submit', this.event_handlers.onUserPropertyFilterSubmit);

            return;
        }

        var selected_filters = this.selected_filters[dropdown_name];
        var filter_options = this.getFilterOptions(dropdown_name);
        var is_all = selected_filters.length === 0;

        var dropdown_html = '<li data-filter="' + dropdown_name + '" data-val="-1"' + (is_all ? ' class="selected"' : '') + '>All</li>';

        filter_options.options.forEach((option) => {
            if (option.name === 'separator') {
                dropdown_html += '<li class="separator"></li>';
            } else {
                var filter_name = option.filter || dropdown_name;
                var filter_type = typeof this.selected_filters[filter_name];
                var is_selected = filter_type === 'boolean' ? this.selected_filters[filter_name] : selected_filters.indexOf(option.val) !== -1;
                var is_disabled = option.disabled === true;

                var classes = [];

                if (is_selected) {
                    classes.push('selected');
                }

                if (is_disabled) {
                    classes.push('disabled');
                }

                dropdown_html += '<li data-filter="' + filter_name + '" data-val="' + option.val + '"' + (classes.length ? ' class="' + classes.join(' ') + '"' : '') + '>' + option.name + '</li>';
            }
        });

        var html =
        '<div class="button-dropdown button-dropdown-full button-dropdown-left" data-trim="false">' +
            '<button type="button" class="dropdown-select dropdown-select-text">' +
                '<span class="label">' + filter_options.label + '</span>' +
                '<span class="count">' + (selected_filters.length ? selected_filters.length : '') + '</span>' +
            '</button>' +
            '<div>' +
                '<ul class="dropdown dropdown-select">' +
                    dropdown_html +
                '</ul>' +
            '</div>' +
        '</div>';

        if (this.$el.find('[data-type="' + dropdown_name + '"]').find('ul.dropdown').length) {
            this.$el.find('[data-type="' + dropdown_name + '"]').find('.count').text(selected_filters.length ? selected_filters.length : '');
            this.$el.find('[data-type="' + dropdown_name + '"]').find('ul.dropdown').html(dropdown_html);
        } else {
            this.$el.find('[data-type="' + dropdown_name + '"]').html(html);
        }
    },

    render: function() {
        var content =
        '<div data-type="feedback_type"></div>' +
        '<div data-type="workflow"></div>' +
        '<div data-type="assignee"></div>' +
        '<div data-type="priority"></div>' +
        '<div data-type="category"></div>' +
        (this.is_design ? '' :
        (Cache.account.hasFeature('user_segment') ?
        '<div data-type="segment"></div>' : '') +
        '<div data-type="user-property"">' +
            '<div class="button-dropdown">' +
                '<button type="button" class="user-filter-toggle dropdown-select dropdown-select-text">' +
                    '<span class="label">User Property</span>' +
                    '<span class="count">' + (this.selected_filters.user_property ? this.selected_filters.user_property.segment_condition.length : '') + '</span>' +
                '</button>' +
            '</div>' +
            '<div class="region-user-properties"></div>' +
        '</div>');

        this.$el.html(content);

        this.renderDropdown('workflow');
        this.renderDropdown('assignee');
        this.renderDropdown('priority');
        this.renderDropdown('category');

        if (!this.is_design) {
            this.renderDropdown('feedback_type');
            this.renderDropdown('segment');
            this.renderDropdown('user_property');
        }

        return this;
    }
});